import React from 'react';

const EntireCottageHostedByJesse = {
	id: 6, thumb: "https://a0.muscache.com/im/pictures/286b0d34-f134-4e30-80df-5dfeb9498811.jpg?aki_policy=x_large", img: "https://a0.muscache.com/im/pictures/7201228b-cbf5-4c78-bda2-d86c0d23f058.jpg?aki_policy=large", permalink: "entire-cottage-hosted-by-jesse", title: "Entire Cottage Hosted by Jesse", city: "Crafers", location: "Crafers, South Australia, Australia", cost: 345, guests: 4, bedrooms: 2, beds: 2, baths: 2, reviews: 34, star: 5, advantage: { "Entire home": "You’ll have the cottage to yourself.", "Sally is a Superhost": "Superhosts are experienced, highly rated hosts who are committed to providing great stays for guests." }, rules: <>
		<ul>
			<li>Self check-in with lockbox</li>
			<li>No smoking</li>
			<li>No pets</li>
			<li>No parties or events</li>
		</ul>
	</>, content: <>
		Our Pinot Cottage (number one) is an amazingly light and bright semi-detached self-contained accommodation, nestled into the side of the Mt Lofty Ranges offering total privacy and solitude. Contemporary by style and totally brand new inside, this exc

		Our Pinot Cottage (number one) is an amazingly light and bright semi-detached self-contained accommodation, nestled into the side of the Mt Lofty Ranges offering total privacy and solitude. Contemporary by style and totally brand new inside.

		Please join us at 5 pm everyday for a complimentary history & art tour for Mount Lofty House.
	</>
};
export default EntireCottageHostedByJesse;